import { Module } from 'vuex'
import { FoldersState, state } from './folders.model'
import { actions } from './folders.actions'
import { mutations } from './folders.mutations'
import { getters } from './folders.getters'

export const folderModule: Module<FoldersState, unknown> = {
  state,
  actions,
  mutations,
  getters
}
